<template>
  <div class="lang-switch" :class="{ 'is-dark': theme === 'dark' }" role="group" aria-label="Language">
    <button
      type="button"
      class="lang-btn"
      :class="{ active: locale === 'zh-CN' }"
      @click="change('zh-CN')"
    >
      {{ $t("lang.zh") }}
    </button>
    <span class="lang-sep">/</span>
    <button
      type="button"
      class="lang-btn"
      :class="{ active: locale === 'en-US' }"
      @click="change('en-US')"
    >
      {{ $t("lang.en") }}
    </button>
  </div>
</template>

<script>
import { i18nState, setLocale } from "@/i18n";

export default {
  name: "LanguageSwitch",
  props: {
    theme: {
      type: String,
      default: "light",
    },
  },
  computed: {
    locale() {
      return i18nState.locale;
    },
  },
  methods: {
    change(locale) {
      if (locale === this.locale) {
        return;
      }
      setLocale(locale);
    },
  },
};
</script>

<style scoped lang="scss">
.lang-switch {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  user-select: none;
}
.lang-btn {
  border: none;
  background: transparent;
  padding: 0 4px;
  font-size: 14px;
  line-height: 1;
  color: #909399;
  cursor: pointer;
  &.active {
    color: #303133;
    font-weight: 600;
  }
  &:hover {
    color: #409eff;
  }
}
.lang-sep {
  color: #c0c4cc;
  font-size: 12px;
  margin: 0 2px;
}
.lang-switch.is-dark {
  .lang-btn {
    color: rgba(255, 255, 255, 0.72);
    &.active {
      color: #fff;
    }
    &:hover {
      color: #fff;
    }
  }
  .lang-sep {
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>
